/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * AngularJs component that displays list of google photo to import into Bulb.
 */
angular.module('bulbApp.assetLibraryModule')
  .constant('MAX_ITEM_THRESHOLD_SIZE', 50)
  .component('assetLibraryGooglePhoto', {
    templateUrl: 'ajs/assetlibrary/google-photo/assetlibrary-google-photo.html',
    controllerAs: 'googlePhotoCtrl',
    controller: [
      'BulbAssetLibraryService',
      'BulbAssetLibraryGooglePhotoService',
      'BulbBusyCoverService',
      'MAX_ITEM_THRESHOLD_SIZE',
      '_',
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      AssetLibraryGooglePhotoController,
    ],
  });

function AssetLibraryGooglePhotoController(
  BulbAssetLibraryService: { dialog: { closeCurrentModal: () => void; }; },
  BulbAssetLibraryGooglePhotoService: any,
  BulbBusyCoverService: { showBusy: () => any; },
  MAX_ITEM_THRESHOLD_SIZE: number,
  _: any,
) {
  const that = this;
  this.stopBusyIndicatorCallback = null;
  this.selectedAlbumName = '';
  this.selectedMediaItemId = [];
  this.selectedAlbumId = '';
  this.query = null;
  this.currentView = 'tiles';
  this.mediaItemsFound = true;
  this.isAscending = true;
  this.isSearch = false;
  let slice = MAX_ITEM_THRESHOLD_SIZE;

  this.mediaItemList = BulbAssetLibraryGooglePhotoService.mediaItemList.slice(0, MAX_ITEM_THRESHOLD_SIZE);
  this.albumList = BulbAssetLibraryGooglePhotoService.albumList;
  this.allowMultipleSelection = BulbAssetLibraryGooglePhotoService.allowMultipleSelection;
  this.showOnlyVideo = BulbAssetLibraryGooglePhotoService.showOnlyVideo;

  function scrollToTop() {
    $('.bulb-assetlibrary-googlephoto-scrollbox').scrollTop(0);
    slice = MAX_ITEM_THRESHOLD_SIZE;
  }

  /**
   * Set list of photos after search image and refreshed image list.
   */
  function setMediaItems() {
    that.query = '';
    that.mediaItemsFound = that.mediaItemList.length > 0;
    if (that.stopBusyIndicatorCallback) {
      that.stopBusyIndicatorCallback();
    }
  }

  /**
   * Toggle List/Tile View.
   * @param viewType To show in google picker.
   */
  this.switchView = function switchView(viewType) {
    that.selectedMediaItemId.length = 0;
    that.currentView = viewType;
  };

  /**
   * Show list of photos for selected album.
   * @param albumId id of album.
   * @param albumTitle title of album.
   */
  this.openAlbum = function openAlbum(albumId, albumTitle) {
    that.stopBusyIndicatorCallback = BulbBusyCoverService.showBusy();
    BulbAssetLibraryGooglePhotoService.getAlbumPhotos(albumId, true).then(() => {
      scrollToTop();
      this.mediaItemList = BulbAssetLibraryGooglePhotoService.mediaItemList.slice(0, MAX_ITEM_THRESHOLD_SIZE);
      setMediaItems();
      that.selectedAlbumName = albumTitle;
      that.isSearch = false;
    }, () => that.stopBusyIndicatorCallback());
  };

  /**
   * Show photos on breadcrumb click.
   */
  this.showMediaItems = function showMediaItems() {
    that.selectedAlbumId = null;
    that.selectedMediaItemId.length = 0;
    that.stopBusyIndicatorCallback = BulbBusyCoverService.showBusy();
    BulbAssetLibraryGooglePhotoService.getAlbumPhotos(null, true).then(() => {
      scrollToTop();
      this.mediaItemList = BulbAssetLibraryGooglePhotoService.mediaItemList.slice(0, MAX_ITEM_THRESHOLD_SIZE);
      setMediaItems();
      that.albumList = BulbAssetLibraryGooglePhotoService.albumList;
      that.selectedAlbumName = '';
      that.isSearch = false;
    }, (error) => {
      // eslint-disable-next-line no-console
      console.error('Error while fetching media items', error);
      that.stopBusyIndicatorCallback();
    });
  };

  /**
   *
   */
  this.getMediaItems = function getMediaItems() {
    if (that.query) return;
    if (!that.isAscending) return;
    if (that.mediaItemList.length !== BulbAssetLibraryGooglePhotoService.mediaItemList.length) {
      that.mediaItemList = that.mediaItemList.concat(
        BulbAssetLibraryGooglePhotoService.mediaItemList.slice(slice, slice + MAX_ITEM_THRESHOLD_SIZE),
      );
      slice += MAX_ITEM_THRESHOLD_SIZE;
    }
    if (!BulbAssetLibraryGooglePhotoService.nextPhotoPageToken) {
      return;
    }
    BulbAssetLibraryGooglePhotoService.getAlbumPhotos(that.selectedAlbumId, false).then(() => {
    }, (error) => {
      // eslint-disable-next-line no-console
      console.error('Error while fetching media items', error);
    });
  };

  /**
   * Call on photo selection.
   * @param mediaItemId id of photo.
   */
  this.selectPhoto = function selectPhoto(mediaItemId) {
    const index = that.selectedMediaItemId.indexOf(mediaItemId);
    if (index > -1) {
      that.selectedMediaItemId.splice(index, 1);
    } else {
      if (!that.allowMultipleSelection) {
        that.selectedMediaItemId.length = 0;
      }
      that.selectedMediaItemId.push(mediaItemId);
    }
    that.selectedAlbumId = '';
  };

  /**
   * Call on album selection.
   * @param albumId id of album.
   */
  this.selectAlbum = function selectAlbum(albumId) {
    that.selectedAlbumId = albumId;
    that.selectedMediaItemId.length = 0;
  };

  /**
   * Method to upload selected photo.
   */
  this.uploadSelectedPhoto = function uploadSelectedPhoto() {
    BulbAssetLibraryService.dialog.closeCurrentModal();
    BulbAssetLibraryGooglePhotoService.selectPhotoHandler(that.selectedMediaItemId);
  };

  /**
   * Search photos based on the query.
   */
  this.searchPhoto = function searchPhoto() {
    scrollToTop();
    if (!that.query) {
      that.isSearch = false;
      that.mediaItemList = BulbAssetLibraryGooglePhotoService.mediaItemList.slice(0, MAX_ITEM_THRESHOLD_SIZE);
      that.albumList = BulbAssetLibraryGooglePhotoService.albumList;
      return;
    }
    that.isSearch = true;
    that.mediaItemList = BulbAssetLibraryGooglePhotoService.mediaItemList
      .filter((mediaItem) => mediaItem.filename.toLowerCase().indexOf(that.query.toLowerCase()) > -1);
    that.albumList = BulbAssetLibraryGooglePhotoService.albumList
      .filter((album) => album.title.toLowerCase().indexOf(that.query.toLowerCase()) > -1);
  };

  /**
   * Sort the Photo/Album List.
   */
  this.sortList = function sortList() {
    scrollToTop();
    // eslint-disable-next-line no-nested-ternary
    if (that.isAscending) {
      that.mediaItemList = _.sortBy(that.mediaItemList, 'filename');
      that.albumList = _.sortBy(that.albumList, 'title');
    } else {
      that.mediaItemList = _.sortBy(that.mediaItemList, 'filename').reverse();
      that.albumList = _.sortBy(that.albumList, 'title').reverse();
    }
    that.isAscending = !that.isAscending;
  };

  /**
   * Handle the enter key for search.
   * @param event
   */
  this.queryOnKeyDown = function queryOnKeyDown(event) {
    // eslint-disable-next-line default-case
    switch (event.keyCode) {
      case 13: // enter
        that.query = event.currentTarget.value;
        that.searchPhoto();
        break;
    }
  };

  /**
   * Close modal on cancel.
   */
  this.cancel = function cancel() {
    BulbAssetLibraryService.dialog.closeCurrentModal();
  };
}
